import { Children } from "react";

import { List, useDynamicRowHeight } from "react-window";

import { css } from "@emotion/react";

import { calculateVirtualizedContainerHeight } from "components/Filters/functions";

import RowComponent from "./RowComponent";

const AutocompleteListBox = ({ ref, ...props }: any) => {
    const { children, ownerState: _ownerState, ...other } = props;

    const dataArray = Children.toArray(children).map(
        (child: any) => child.props
    );

    const dataArayCount = dataArray.length;
    const hasDescription = Array.isArray(dataArray[0].children);

    const rowHeight = useDynamicRowHeight({
        defaultRowHeight: hasDescription ? 60 : 48
    });

    const containerHeight = calculateVirtualizedContainerHeight(
        dataArayCount,
        4,
        rowHeight
    );

    return (
        <div
            ref={ref}
            {...other}
            css={css({
                height: `${containerHeight}px`
            })}
        >
            <List
                rowComponent={RowComponent}
                rowCount={dataArayCount}
                rowHeight={rowHeight}
                rowProps={{ dataArray }}
                overscanCount={5}
            />
        </div>
    );
};

export default AutocompleteListBox;
